export default __webpack_public_path__ + "static/media/logo-cdp.5140881a.png";